const posterNeedsCapture = (poster) =>
	poster &&
	poster.dataset.posterReady !== "true" &&
	!poster.getAttribute("src");

const captureFirstFrame = (video, poster) => {
	if (!posterNeedsCapture(poster)) {
		return;
	}

	let captured = false;

	const draw = () => {
		if (captured || !video.videoWidth || !video.videoHeight) {
			return;
		}

		try {
			const canvas = document.createElement("canvas");
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
			poster.src = canvas.toDataURL("image/jpeg", 0.85);
			poster.hidden = false;
			poster.dataset.posterReady = "true";
			captured = true;
		} catch {
			// Cross-origin or tainted canvas — keep manual poster if present.
		}
	};

	const seekAndDraw = () => {
		const onSeeked = () => {
			video.removeEventListener("seeked", onSeeked);
			draw();
		};

		video.addEventListener("seeked", onSeeked, { once: true });

		const target =
			Number.isFinite(video.duration) && video.duration > 0
				? Math.min(0.1, video.duration / 10)
				: 0.001;

		try {
			video.currentTime = target;
		} catch {
			draw();
		}
	};

	const prepareFrame = () => {
		if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
			draw();
		}

		if (!captured) {
			seekAndDraw();
		}
	};

	if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
		prepareFrame();
		return;
	}

	video.addEventListener("loadedmetadata", prepareFrame, { once: true });
};

const setupVideoPoster = (media) => {
	const video = media.querySelector(".alternating-videos__video");
	const poster = media.querySelector(".alternating-videos__poster[data-poster-auto]");

	if (!video || !posterNeedsCapture(poster)) {
		return;
	}

	video.preload = "auto";

	if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
		captureFirstFrame(video, poster);
		return;
	}

	const startCapture = () => {
		captureFirstFrame(video, poster);
	};

	video.addEventListener("loadedmetadata", startCapture, { once: true });

	if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
		video.load();
	}
};

const initSection = (section) => {
	section.querySelectorAll(".alternating-videos__media.has-video").forEach(setupVideoPoster);

	section.querySelectorAll(".alternating-videos__play").forEach((button) => {
		button.addEventListener("click", () => {
			const media = button.closest(".alternating-videos__media");
			const video = media?.querySelector("video");

			if (!media || !video) {
				return;
			}

			media.classList.add("is-playing");
			video.controls = true;
			video.play().catch(() => {});
		});
	});
};

const init = () => {
	document.querySelectorAll(".alternating-videos").forEach(initSection);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
